var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"span":9}},[_c('page-tree-table')],1),_c('el-col',{attrs:{"span":15}},[_c('page-list-table')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }